import { Box, BoxProps, styled } from "@mui/material";

const TableContainerOut = styled(Box)`
  margin: 0 -30px;
  overflow-x: auto;
  @media (min-width: 799.95px) {
    margin: 0;
  }
`;
const TableContainerIn = styled(Box)`
  margin: 0 30px;
  overflow-y: auto;
  @media (min-width: 799.95px) {
    margin: 0;
  }
  border-radius: 10px;
  border: 1px solid #eaeaea;
  height: 400px;
  display: flex;
  flex-direction: column;
  min-width: fit-content;
  width: 100%;
`;
export const TableContainer = (props: BoxProps) => {
  return (
    <TableContainerOut>
      <TableContainerIn {...props}>{props.children}</TableContainerIn>
    </TableContainerOut>
  );
};
export const Table = styled("table")`
  font-size: 14px;
  width: 100%;
  border-collapse: collapse;
  & thead {
    position: sticky;
    top: 0;
    background: white;
    z-index: 1;
  }
`;
interface TableRowProps {
  variant?: "header" | "mainHeader";
}
export const TableRow = styled("tr")<TableRowProps>`
  height: 30px;
  border-bottom: 1px solid #eaeaea;
  &:last-child {
    border-bottom: none;
  }
  ${(props) =>
    props.variant === "header"
      ? `
    font-weight: 800;
    text-align: center;
    border-bottom: none;
  `
      : props.variant === "mainHeader"
      ? `
    box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.1);
    font-weight: 800;
    height: 40px;
    text-wrap: nowrap;
    text-align: center;`
      : `
    cursor: pointer;
    &:hover {
      background: #f5f5f5;
    }
      `}
`;
interface TableCellProps {
  computedValue?: boolean;
  textAlign?: "center" | "left" | "right";
}
export const TableCell = styled("td")<TableCellProps>`
  padding: 8px;
  ${(props) =>
    props.computedValue
      ? `
    background: #ccc;
    font-weight: 800;
  `
      : ``}
  & button {
    margin: auto;
  }
  text-align: ${(props) => props.textAlign || "inherit"};
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
`;

export const NoContentContainer = styled("div")`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
